if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function addCheckboxToRaplhsForm( ralphs_form, label, name, required = false ){
    
    let bro = ralphs_form.querySelector( ".gdpr-wrap .gdpr" )

    let div = document.createElement( "div" )
    div.classList.add( "field" )
    div.classList.add( "gdpr" )
    div.classList.add( "clearfix" )

    let checkbox = document.createElement( "input" )
    checkbox.type = "checkbox"
    checkbox.id = 'form_id-4229-'+name
    checkbox.name = name
    checkbox.value = "y"
    if(required){
        checkbox.classList.add('required')
    }

    let label_tag = document.createElement( "label" )
    label_tag.innerHTML = label
    label_tag.setAttribute( "for", "form_id-4229-" + name )

    div.append( checkbox )
    div.append( label_tag )

    bro.after( div )

}

(function(){
    
    let ralphs_form = document.querySelector( "#form_id-4229" )
    if( ralphs_form ){
        addCheckboxToRaplhsForm( ralphs_form, "I would like to receive emails from Ralphs", "Are_you_agree_in_received_email_from_Ralphs", true )
        addCheckboxToRaplhsForm( ralphs_form, "I have read and agree to the <a href='https://www.belmontpark.com/privacy-policy' target='_blank'>Belmont Park Privacy Policy</a>*", "I_have_read_and_agree_to_the_Belmont_Park_Privacy_Policy", true )
    }

    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    document.querySelector( "#email-signup [name=_utm_source]" ).value = document.URL

    $('.sym-slides').slick({
        accessibility: true
    });

    $('.featured-events__slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        asNavFor: '.featured-events__slider-two',
        slide: '.events-slide',
        prevArrow: '.featured-events-prev',
        nextArrow: '.featured-events-next',
        accessibility: true
    })

    $('.featured-events__slider-two').slick({
        arrows: false,
        dots: false,
        autoplay: false,
        infinite: true,
        fade: true,
        speed: 500,
        asNavFor: '.featured-events__slider',
        accessibility: true
    })

    $('.slider-two-images__slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        asNavFor: '.slider-two-images__slider-two',
        slide: '.two-images-slide',
        accessibility: true
    })

    $('.slider-two-images__slider-two').slick({
        arrows: false,
        dots: false,
        autoplay: false,
        infinite: true,
        fade: true,
        speed: 500,
        asNavFor: '.slider-two-images__slider',
        accessibility: true
    })

    $('.slider-months__mobile').slick({
        accessibility: true,
        arrows: true,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: "0px"
    });
    

    if(document.querySelector('.park-map')){
        let attractions = document.querySelectorAll('[data-point]');
        attractions.forEach(function(element){
            element.addEventListener('click', function(e){
                let data = e.target.dataset.point;
                attractions.forEach(function(item){
                    item.classList.toggle('active',item.dataset.point == data);
                })
            })
        })
    }

    $('.carousel__slider').slick({
        dots: true,
        arrows: false,
        variableWidth: true,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 6000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: true,
                    dots: false
                }
            }
        ]
    });

    $('.cards__slider').slick({
        arrows: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 7000,
        speed: 500,
        infinite: false,
        slidesToShow:3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.cards-v2__slider').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        infinite: false,
        slidesToShow:3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    centerMode: true,
                    infinite: true,
                    dots: true
                }
            }
        ]
    });

    if(document.getElementsByClassName('js-accordion-title')){        
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });

        document.querySelectorAll('.menus-quad').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
    }

    $('.columns-slider__slider').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        infinite: true,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    let menuItems = document.querySelectorAll('.no-click');
    menuItems.forEach((itemMenu)=>{
        itemMenu.addEventListener('click',(e)=>{
            e.preventDefault();
        });
    });

    let subMenus = document.querySelectorAll('.privary-navigation__submenu');
    subMenus.forEach((submenu)=>{
        if(submenu.querySelector('.active') != null){
            if(((submenu.querySelector('.active').parentNode).parentNode).previousSibling.previousSibling.classList.contains('no-click')){
                ((submenu.querySelector('.active').parentNode).parentNode).classList.add('show');
                ((submenu.querySelector('.active').parentNode).parentNode).previousSibling.previousSibling.classList.add('parent-active');
            }
        }
    });

    let menuActive = document.querySelectorAll('.privary-navigation__item > a');
    menuActive.forEach((itemA)=>{
        if(itemA.classList.contains('parent-active') && itemA.nextElementSibling != null){
            itemA.nextElementSibling.classList.add('show');
        }
    });


    $('.gallery-quad__images').slick({
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: true,
        slide: '.slide-gallery',
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true,
                    dots: true,
                    arrows:false
                }
            }
        ]
    });

    if(document.querySelector('.intro-content-restaurants')){
        if(document.querySelector('.hours-restaurant')){
            document.querySelector('.intro-content-restaurants .container').appendChild(document.querySelector('.hours-restaurant'));
        } else {
            document.querySelector('.intro-content-restaurants').classList.add('no-hours')
        }
    }

    //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_first_names').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    // ADD CUSTOM CHECKBOX TO FORM
    let form_id_4012 = document.querySelector( "#form_id-4012" ) 
    if( form_id_4012 ){

        let checkboxWrap = document.createElement( 'div' )
        checkboxWrap.setAttribute( "class", 'field gdpr clearfix' );
        checkboxWrap.innerHTML = '<input type="checkbox" name="receive_the_latest_updates" id="form_id-4012-receive_the_latest_updates" value="y" aria-required="true"> <label for="form_id-4012-receive_the_latest_updates">Opt in to receive the latest updates on Cobian’s products, ambassadors, and events.</label>'
        
        form_id_4012.querySelector( ".gdpr-wrap " ).appendChild( checkboxWrap )
    }

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    $('.carousel-thumb__slider').slick({
        dots: true,
        arrows: false,
        variableWidth: true,
        centerMode: true
    });

    if(document.querySelector('.columns-grid__filter')){
        const tabs = document.querySelectorAll('.columns-grid__filter ul li');
        const itemsTabs = document.querySelectorAll('.columns-grid__item');
        tabs.forEach(function(tab){
            tab.addEventListener('click',(e)=>{
                tabs.forEach(function(tab2){
                    tab2.classList.remove('active');
                });
                tab.classList.add('active');
                let dataTag = e.target.dataset.tag;
                itemsTabs.forEach((item) => {
                    if(dataTag == 'all'){
                        item.classList.remove('hidden')
                    }else if(dataTag == item.dataset.tag){
                        item.classList.remove('hidden');
                    }else{
                        item.classList.add('hidden');
                    }
                });
            })
        });
    }

    if(document.querySelector('.form-module-wrapper')){
        document.querySelectorAll('.form-module-wrapper').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    if(document.querySelector('.text-modules-wrapper')){
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    if(document.querySelector('.highlights') && window.innerWidth > 1024){
        let imagesHover = document.querySelectorAll('.highlights__item figure img');
        imagesHover.forEach((img)=>{
            img.addEventListener('mouseenter',()=>{
                let srcHover = img.dataset.hover;
                img.src = srcHover;
            });

            img.addEventListener('mouseout',()=>{
                let src = img.dataset.src;
                img.src = src;
            })
        })
    }

    //dropdown for mobile
    if(document.querySelector('.menu-responsive')){
        document.querySelectorAll('.inner > ul > li > a').forEach(link => {
            link.addEventListener('click', e => {
                if (link.nextSibling.nextSibling != null) {
                    document.querySelectorAll('.inner > ul > li').forEach(item => {
                        if (link.parentNode !== item) item.classList.remove('js-submenu-show');
                    });
                    //remove this comment if you want show subnav for mobile
                    e.preventDefault();
                    link.parentNode.classList.toggle('js-submenu-show');
                }
            });
        });
    }

    //Menus tabs js
    if(document.querySelector('.menus-quad')){
        const MENUCONTAINER = document.querySelectorAll('.menus-quad');
        let lastClick = null;
        MENUCONTAINER.forEach(container => {
            let tabsMenus = container.querySelectorAll('.menus-quad__tab');
            let menus = container.querySelectorAll('.menus-quad__menu');
            tabsMenus.forEach(tab =>{
                tab.addEventListener('click',(e)=>{
                    if(lastClick){
                        lastClick.classList.remove('active');
                    }
                    tab.classList.add('active');
                    let data = tab.dataset.menu;
                    console.log(data);
                    menus.forEach(menu=>{
                        menu.classList.toggle('hidden',menu.dataset.menu != data);
                        menu.classList.toggle('not-show',menu.dataset.menu != data);
                    })
                    lastClick = tab;
                })
            })
        })
    }

    /** Updated  input name time  */
    document.querySelectorAll('input[name="start_time"], input[name="end_time"]').forEach(input => {
        input.type = "time";
        
    });   



})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/


function updateMenuTabIndex() {
    const menu = document.querySelector('#menu');
    const isMenuVisible = menu && menu.classList.contains('show');
    const elements = document.querySelectorAll('.privary-navigation__item a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#menu');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});


document.addEventListener('DOMContentLoaded', () => {
   let url_parameters = new URLSearchParams(location.search);
   
   if( url_parameters.get("hash")) {
        document.querySelector(`#${url_parameters.get("hash")}`).scrollIntoView({block:'center', behavior: 'smooth'});
   }
})